export { BasicInfo as ValidatorBasicInfo } from "./ui/basic-info";

import img from "./assets/fallback-validator.png";
export const fallbackValidatorImage = img;
